import { render, staticRenderFns } from "./vipcard.vue?vue&type=template&id=058a2fd3&scoped=true&"
import script from "./vipcard.vue?vue&type=script&lang=js&"
export * from "./vipcard.vue?vue&type=script&lang=js&"
import style0 from "./vipcard.vue?vue&type=style&index=0&id=058a2fd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a2fd3",
  null
  
)

export default component.exports